import React, { useEffect, useState } from 'react';
import styles from "./index.module.scss";
import {useSelector} from "react-redux";
import {phoneNumberFormat} from "../../utils";
import {File, Order} from "../../services";
import {useNavigate} from "react-router-dom";
import ProfileCompanyCount from "./components/OrdersCount/ProfileCompanyCount";
import ProfileDocuments from "./components/UploadDocuments/ProfileDocuments";
import ProfilePassword from "./components/ProfilePassword/ProfilePassword";
import ChangeAvatar from "./components/ChangeAvatar/ChangeAvatar";
import {get, post} from "../../services/config";
import { motion } from "framer-motion";
import moment from 'moment';
import {useAnimationConfig} from "../../hooks/useAnimationConfig";
import EditIcon from '../shared/icons/EditIcon';
import { useTranslation } from 'react-i18next';

const ProfilePageComponentTwo = ({ changeDisplay, changeModeration}) => {
  const { t } = useTranslation();
  const { user } = useSelector(state => state);
  const navigate = useNavigate();
    const { routeVariants} = useAnimationConfig()
    const [binData, setBinData] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [ordersCount, setOrdersCount] = useState(null);

    const isExpeditor = user.type === "Expeditor";
    const companyId = user.companyId === null? "" : user.companyId; 

    const BIN_LENGTH = 12
    const IIN_LENGTH = 12
    const [isEditing, setIsEditing] = useState(false);
    const [tempUser, setTempUser] = useState({
        surname: user.surname,
        name: user.name,
        bin: user.bin,
        iin: user.iin,
        phoneNumber: user.phoneNumber,
        address: user.address,
        isNDS: user.isNDS !== undefined ? user.isNDS : false
    });

    const handleEditClick = () => {
        setIsEditing(true);
    };
    const handleCancelClick = () => {
        setIsEditing(false);
    };

    const handleSaveChanges = async () => {
        try {
            console.log('Saving user data:', tempUser);
            const response = await post('/v1/users/update', tempUser);
            if (response.status === 200) {
                console.log(t('profileTwo.toast.saveSuccess')); // Use translation
                setIsEditing(false);
                window.location.reload();
            } else {
                console.log(t('profileTwo.toast.saveError')); // Use translation
            }
        } catch (error) {
            console.error(t('profileTwo.toast.saveError'), error); // Use translation
        }
    };

    const handleInputChange = (event) => {
        const { name, value, type, checked } = event.target;
        if (type === "checkbox") {
            setTempUser(prevState => ({ ...prevState, [name]: checked }));
        } else {
            setTempUser(prevState => ({ ...prevState, [name]: value }));
        }
    };

    useEffect(() => {
            Order.getCompletedOrdersCount(companyId).then((response) => {
                // console.log(response.data);
                if(response.status == 200) {
                    setOrdersCount(response.data)
                }
            }).catch(error => {
                console.log(error);
            })
    }, [user]);
    const onOpenModal = (type) => {
        // console.log(type)
        setIsModalOpen(true);
    };
    const closeModal = () => {
        setIsModalOpen(false);
    };

    // useEffect(() => {
    //     if(user?.businessIdentificationNumber)  {
    //         getInfoByBin(user.businessIdentificationNumber)
    //     }
    // }, [user])

    // const getInfoByBin = async (bin) => {
    //     try {
    //         const { data } = await get(`/v1/users/gov/juridical`, { params: {
    //                 bin, lang: "ru"
    //             }})
    //         if (!data.success) {
    //             throw data
    //         }
    //         setBinData(data.obj)
    //     } catch (e) {
    //         console.log("error", e)
    //     }
    // }

    const openDocument = (type) => {
        File.get(type)
            .then(response => {

                // console.log(response);

                const file = new Blob([response.data], {
                    type: response.data.type,
                });

                const fileURL = URL.createObjectURL(file);
                window.open(fileURL);

            })
            .catch(error => {
                console.log(error);
                console.log(t('profileTwo.toast.genericError')); // Use translation
                alert(t('profileTwo.toast.genericError')); // Use translation
            });
    }

    const changePassword = () =>{
        navigate('/change-password')
    }

    // console.log('USER ---->', user)

  const formattedDate = moment(user.createdAt).format('DD.MM.YYYY');

    return(
        <motion.div
          variants={routeVariants}
          initial="initial"
          animate="final"
          className={styles['profile__page']}
        >
            <div className={styles['profile__page-title']}>
              {t('profileTwo.title.profile')}
              { isExpeditor ? t('profileTwo.title.expeditor') : t('profileTwo.title.company')}
            </div>
            <div className={styles['profile__company']}>
                <div className={styles['profile__company-title']}>{user.companyName}</div>
                <hr className={styles['profile__company-hr']} />

                {isEditing ? (
                    <div>
                        <div className={styles['profile__company-header']}>
                            <ChangeAvatar
                                onOpenModal={onOpenModal}
                                user={user}
                            />
                            <div className='profile__company-df'>
                                <div className={styles['profile__contact-title']}>{t('profileTwo.placeholder.surname')}</div>
                                <input className={styles['profile__contact-edit']}
                                    name='surname'
                                    value={tempUser.surname}
                                    onChange={handleInputChange}
                                    size="lg"
                                    type="text"
                                    placeholder={t('profileTwo.placeholder.surname')}
                                />
                                <EditIcon/>

                                <div className={styles['profile__contact-title']}>{t('driversCreate.label.name')}</div>
                                <input className={styles['profile__contact-edit']}
                                    name='name'
                                    value={tempUser.name}
                                    onChange={handleInputChange}
                                    size="lg"
                                    type="text"
                                    placeholder={t('driversCreate.placeholder.enterName')}
                                />
                                <EditIcon/>
                            </div>
                            {/* <div className='profile__company-df'> 
                               
                            </div> */}
                        </div>
                    </div>
                ) : (
                    <div className={styles['profile__company-header']} style={{justifyContent: "space-between"}}>
                        <div style={{display: "flex", alignItems: "center"}}>
                            <ChangeAvatar
                                onOpenModal={onOpenModal}
                                user={user}
                            />
                            <div className={styles['profile__company-content']}>
                                {user.role === 'Employee' || user.role === 'Admin'? (
                                    <>
                                        <div className={styles['profile__company-name']}>{user.name}</div>
                                        <div className={styles['profile__company-name']}>{user.surname} {user.patronymic}</div>
                                    </>
                                ) : (
                                    <>
                                        <div className={styles['profile__company-name']}>{user.surname}</div>
                                        <div className={styles['profile__company-name']}>{user.name} {user.patronymic}</div>
                                    </>
                                )}
                            </div>
                        </div>

                        <button title={t('profileTwo.button.edit')} className={styles['profile__upload-button']} onClick={handleEditClick}>{t('profileTwo.button.edit')}</button>
                    </div>
                )}

               <ProfileCompanyCount totalCount={ordersCount?.totalCount} totalSum={ordersCount?.totalSum}/>
                <div className={styles['profile__contact']}>
                    {isEditing ? (
                        <>
                            <div className={styles['profile__contact-title']}>{t('profileTwo.label.bin')}</div>
                            <input className={styles['profile__contact-edit']}
                                   name='bin'
                                   value={tempUser.bin}
                                   onChange={handleInputChange}
                                   size="lg"
                                   type="text"
                                   placeholder="123456789012"
                                   maxLength={BIN_LENGTH}
                            />
                            <EditIcon/>

                            <div className={styles['profile__contact-title']}>{t('profileTwo.label.iin')}</div>
                            <input className={styles['profile__contact-edit']}
                                   name='iin'
                                   value={tempUser.iin}
                                   onChange={handleInputChange}
                                   size="lg"
                                   type="text"
                                   placeholder="123456789012"
                                   maxLength={IIN_LENGTH}
                                   disabled={true}
                            />

                            <div className={styles['profile__contact-title']}>{t('profileTwo.label.phoneNumber')}</div>
                            <input className={styles['profile__contact-edit']}
                                   name='phoneNumber'
                                   value={tempUser.phoneNumber}
                                   onChange={handleInputChange}
                                   size="lg"
                                   type="text"
                                   placeholder={t('profileTwo.placeholder.phoneNumber')}
                            />
                            <EditIcon/>
                        </>
                    ) : (
                        <>
                            <div className={styles['profile__contact-title']}>{t('profileTwo.label.bin')}</div>
                            <div className={styles['profile__contact-subtitle']}>{user.bin}</div>
                            <div className={styles['profile__contact-title']}>{t('profileTwo.label.iin')}</div>
                            <div className={styles['profile__contact-subtitle']}>{user.iin}</div>
                            <div className={styles['profile__contact-title']}>{t('profileTwo.label.phoneNumber')}</div>
                            <div className={styles['profile__contact-subtitle']}>
                                {user.phoneNumber && phoneNumberFormat(user.phoneNumber)}
                            </div>
                        </>
                    )}
                    <div className={styles['profile__contact-title']}>{t('profileTwo.label.email')}</div>
                    <div className={styles['profile__contact-subtitle']}>{user.email}</div>

                    {isEditing ? (
                        <div className="form-check" style={{ marginTop: '20px'}}>
                            <label className="form-check-label" htmlFor="flexCheckChecked">
                                {t('profileTwo.nds.checkboxLabel')}
                            </label>
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="flexCheckChecked"
                                name='isNDS'
                                checked={tempUser.isNDS} 
                                onChange={handleInputChange}
                            />
                        </div>
                    ) : (
                        <>
                            <div className={styles['profile__contact-title']}>{t('profileTwo.nds.label')}</div>
                            <div className={styles['profile__contact-subtitle']}>
                                {user.isNDS ? t('profileTwo.nds.included') : t('profileTwo.nds.notIncluded')}
                            </div>
                        </>
                    )}

                    {isEditing ? (
                        <>
                            <div className={styles['profile__contact-title']}>{t('profileTwo.label.orgAddress')}</div>
                            <textarea className="form-control textarea_edit" style={{ border:'1.6px solid #ECEDEE', marginTop:'12px' }} id="exampleFormControlTextarea1" rows="2"
                                name='address'
                                value={tempUser.address}
                                onChange={handleInputChange}
                                size="lg"
                                type="text"
                                placeholder={t('profileTwo.placeholder.orgAddress')}
                            >
                            </textarea>
                        </>
                    ) : (
                        <>
                            <div className={styles['profile__contact-title']}>{t('profileTwo.label.orgAddress')}</div>
                            <div className={styles['profile__contact-subtitle']}>{user.address}</div>
                        </>
                    )}
                    <div className={styles['profile__contact-title']}> {t('profileTwo.label.registered')} </div>
                    <div className={styles['profile__contact-subtitle']}>
                      {formattedDate}
                    </div>
                    {isEditing ? (
                        <div className={styles['profile__upload-block']}>
                            <button className={styles['profile__upload-button']} onClick={handleCancelClick}>{t('profileTwo.button.cancelChanges')}</button>
                            <button className={styles['profile__upload-button']} onClick={handleSaveChanges}>{t('profileTwo.button.saveChanges')}</button>
                        </div>
                    ) : (
                        // <button className={styles['profile__upload-button']} style={{marginTop: '20px'}} onClick={handleEditClick}>Редактировать</button>
                        null
                    )}
                </div>
            </div>
            <ProfileDocuments user={user} onOpenModal={onOpenModal} openDocument={openDocument}/>
            <ProfilePassword user={user} onOpenModal={onOpenModal} closeModal= {closeModal} isModalOpen={isModalOpen} changePassword={changePassword} changeDisplay={changeDisplay} changeModeration={changeModeration}/>
        </motion.div>
    )
}

export default ProfilePageComponentTwo;
